import { apiCall } from "../service/api-service";

export const getLeadCountApi = async (params) => {
  const response = await apiCall("GET", "dashboard/count", null, { params });
  return response.data;
};

export const getLineChartDataApi = async (params) => {
  const response = await apiCall("GET", "dashboard/lead_over_time", null, { params });
  return response.data;
};

export const getLeadSourceDataApi = async (params) => {
  const response = await apiCall("GET", "dashboard/lead_by_source", null, { params });
  return response.data;
};

export const getLeadOwnerDataApi = async (params) => {
  const response = await apiCall("GET", "dashboard/lead_by_owner", null, { params });
  return response.data;
};

export const getLeadStageDataApi = async (params) => {
  const response = await apiCall("GET", "dashboard/lead_status_count", null, { params });
  return response.data;
};

export const getCountryBasedDataApi = async (params) => {
  const response = await apiCall("GET", "dashboard/location_based/country", null, { params });
  return response.data;
};

export const getCityBasedDataApi = async (params) => {
  const response = await apiCall("GET", "dashboard/location_based/city", null, { params });
  return response.data;
};

export const getConvertedAndLostLeads = async (params) => {
  const response = await apiCall("GET", "dashboard/convert_count", null, { params });
  return response.data;
};

export const convertStatusCount = async (params) => {
  const response = await apiCall("GET", "dashboard/monthly_count", null, { params });
  return response.data;
};

export const getLeadConvertionRate = async (params) => {
  const response = await apiCall("GET", "dashboard/conversion_ratio", null, { params });
  return response.data;
};

// Revenue dashboard
export const getRevenueCountsApi = async (params) => {
  const response = await apiCall("GET", "revenue_dashboard/counts", null, { params });
  return response.data;
};

export const getQuotationOverviewApi = async (params) => {
  const response = await apiCall("GET", "revenue_dashboard/quotation_overview", null, { params });
  return response.data;
};

export const getInvoiceOverviewApi = async (params) => {
  const response = await apiCall("GET", "revenue_dashboard/invoice_overview", null, { params });
  return response.data;
};

export const getRevenueOverviewApi = async (params) => {
  const response = await apiCall("GET", "revenue_dashboard/revenue_overview", null, { params });
  return response.data;
};

export const getRecentPaymentsApi = async (params) => {
  const response = await apiCall("GET", "revenue_dashboard/recent_payments", null, { params });
  return response.data;
};

export const getTransactionsOverviewApi = async (params) => {
  const response = await apiCall("GET", "revenue_dashboard/transactions_overview", null, { params });
  return response.data;
};

export const getPaymentTargetOverviewApi = async (params) => {
  const response = await apiCall("GET", "revenue_dashboard/payment_target_overview", null, { params });
  return response.data;
};

export const getCustomerPaymentOverviewApi = async (params) => {
  const response = await apiCall("GET", "revenue_dashboard/customer_payment_overview", null, { params });
  return response.data;
};

export const getCountryPaymentOverviewApi = async (params) => {
  const response = await apiCall("GET", "revenue_dashboard/country_payment_overview", null, { params });
  return response.data;
};

export const getCustomerInvoiceOverviewApi = async (params) => {
  const response = await apiCall("GET", "revenue_dashboard/customer_invoice_overview", null, { params });
  return response.data;
};

export const getPaymentMethodsOverviewApi = async (params) => {
  const response = await apiCall("GET", "revenue_dashboard/payment_methods_overview", null, { params });
  return response.data;
};


// Forecast dashboard - one call covers every module on the page.
export const getForecastOverviewApi = async (params) => {
  const response = await apiCall("GET", "forecast/overview", null, { params });
  return response.data;
};

// Next-action dashboard - every module's worklist in one call.
export const getNextActionOverviewApi = async (params) => {
  const response = await apiCall("GET", "next_action/overview", null, { params });
  return response.data;
};
